import { msg } from '@lingui/core/macro';
import type { MessageDescriptor } from '@lingui/core';

import { IOnboardingData } from '../providers/onboarding/onboarding.actions';
import { UserData } from '../components/Optimizer/types';
import { ASSET_TYPE, EXPENSE_TYPE, INCOME_TYPE } from '../services/financial-snapshot.service';

export const mapOnboardingToUserCreate = (data: IOnboardingData) => {
  const result = {
    goal: data.goal,
    source: data.source,
    sendEmail: data.sendEmail,
    sendSMS: data.sendSMS,
    firstName: data.personalInfo.firstName,
    lastName: data.personalInfo.lastName,
    phone: data.personalInfo.primaryPhone,
    address: {
      line1: data.personalInfo.address.line1,
      line2: data.personalInfo.address.line2,
      city: data.personalInfo.address.city,
      stateAbbr: data.personalInfo.address.state,
      zipCode: data.personalInfo.address.zipCode,
    },
    loanInterestStatus: data.loanInterestStatus,
    prequal0: data.prequal0,
    isRenting: data.livingSituation.isRenting,
    financialSnapshot: {
      income: [{ type: INCOME_TYPE.PRIMARY_ANNUAL, value: data.income.annual }],
      expenses: [],
      assets: [],
    },
  };

  if (data.income.savings) {
    result.financialSnapshot.assets.push({
      type: ASSET_TYPE.LIQUID,
      value: data.income.savings,
    });
  }

  if (data.livingSituation.isRenting) {
    result.financialSnapshot.expenses.push({
      type: EXPENSE_TYPE.PRIMARY_RENT,
      value: data.livingSituation.rent,
    });
  } else {
    result.financialSnapshot.assets.push({
      type: ASSET_TYPE.HOME,
      value: data.livingSituation.homeValue,
    });
  }

  return result;
};

export const getAuthenticationErrorMsg = (error): MessageDescriptor | undefined => {
  switch (error?.code) {
    case 'auth/invalid-email':
      return msg`Please enter a valid email address.`;
    case 'auth/user-not-found':
      return msg`No user found for this email address`;
    case 'auth/wrong-password':
      return msg`Incorrect password.`;
    case 'auth/email-already-in-use':
      return msg`Email already in use.`;
    // Firebase throttles per device and number, and it lifts on its own. "Locked out" read as
    // permanent, so people abandoned the session and came back as a new sign-up instead of waiting.
    case 'auth/too-many-requests':
      return msg`Too many attempts. Please wait a few minutes before trying again.`;
    default:
      return undefined;
  }
};
